// Quick View
$(document).ready(function () {
  quickView();
  initQuickViewModal();
});

function initQuickViewModal() {
  $(document).on('click', '#quick-view', function (e) {
    if ($(e.target).is('#quick-view')) closeQuickView();
  });
  $(document).on('click', '#quick-view-close', function () {
    closeQuickView();
  });
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') closeQuickView();
  });
}

function openQuickView() {
  $('#quick-view').css('display', 'flex').hide().fadeIn(200);
  $('body').addClass('quick-view-open');
}

function closeQuickView() {
  $('#quick-view').fadeOut(200, function () {
    $('body').removeClass('quick-view-open');
  });
}

function moneyFormat(price) {
  var amount = parseFloat(price);
  if (amount > 1000) amount = amount / 100;
  return '$' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function getOptName(opt) {
  return typeof opt === 'string' ? opt : (opt.name || String(opt));
}

// Mirrors product-form.js exactly — requests sections so renderContents() works
function qvAddToCart(variantId, qty, btn) {
  var cartDrawer = document.querySelector('cart-drawer');

  var formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', qty);

  if (cartDrawer) {
    // Must be ONE comma-separated value, not multiple entries — Shopify's API expects this format
    formData.append('sections', cartDrawer.getSectionsToRender().map(function (section) { return section.id; }));
    formData.append('sections_url', window.location.pathname);
    cartDrawer.setActiveElement(document.activeElement);
  }

  // fetchConfig is defined in global.js (already loaded)
  var config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  btn.text('Adding...').attr('aria-disabled', 'true');

  fetch(routes.cart_add_url, config)
    .then(function (r) { return r.json(); })
    .then(function (response) {
      console.log('QV cart add response:', response);
      console.log('QV sections in response:', response.sections);
      if (response.status) {
        var msg = response.description || response.message || 'Error adding to cart';
        btn.text(msg);
        setTimeout(function () { btn.text('Add to Cart').removeAttr('aria-disabled'); }, 2500);
        return;
      }
      if (cartDrawer) {
        console.log('QV calling renderContents on cart-drawer');
        cartDrawer.renderContents(response);
      } else {
        console.warn('QV no cart-drawer element found');
      }
      btn.text('✓ Added');
      setTimeout(function () { btn.text('Add to Cart').removeAttr('aria-disabled'); }, 2000);
    })
    .catch(function (e) {
      console.error('QuickView add to cart error:', e);
      btn.text('Add to Cart').removeAttr('aria-disabled');
    });
}

function renderQuickView(product) {
  var v = product.variants[0];
  var images = product.images || [];
  var firstOptName = product.options && product.options.length ? getOptName(product.options[0]) : '';
  var isDefaultVariant = product.options && product.options.length === 1 && firstOptName === 'Title';

  // Thumbnails
  var thumbsHTML = '';
  images.slice(0, 6).forEach(function (img, i) {
    var src = typeof img === 'string' ? img : img.src;
    thumbsHTML += '<div class="qv-thumb" data-src="' + src + '" style="width:72px;height:72px;border:2px solid ' + (i === 0 ? '#1e3a72' : '#e8eaed') + ';border-radius:4px;cursor:pointer;overflow:hidden;flex-shrink:0;background:#fff;">' +
      '<img src="' + src + '" style="width:100%;height:100%;object-fit:contain;" loading="lazy">' +
      '</div>';
  });

  // Variant selects
  var optionsHTML = '';
  if (!isDefaultVariant && product.options && product.options.length > 0) {
    product.options.forEach(function (opt, optIndex) {
      var optName = getOptName(opt);
      var values = [];
      product.variants.forEach(function (variant) {
        var val = variant.options[optIndex];
        if (val && values.indexOf(val) === -1) values.push(val);
      });
      optionsHTML += '<div style="margin-bottom:10px;">' +
        '<label style="display:block;font-size:11.5px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:5px;">' + optName + '</label>' +
        '<select class="qv-option-select" data-option-index="' + optIndex + '" style="width:100%;padding:9px 12px;border:1.5px solid #e0e3e8;border-radius:4px;font-size:13.5px;font-family:\'DM Sans\',sans-serif;color:#111;background:#fff;cursor:pointer;outline:none;">';
      values.forEach(function (val) {
        optionsHTML += '<option value="' + val + '">' + val + '</option>';
      });
      optionsHTML += '</select></div>';
    });
  }

  // Price
  var priceHTML = '<span class="qv-price" style="font-size:28px;font-weight:800;color:#111;">' + moneyFormat(v.price) + '</span>';
  if (v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)) {
    priceHTML += ' <span style="font-size:14px;color:#aab0bc;text-decoration:line-through;margin-left:6px;">' + moneyFormat(v.compare_at_price) + '</span>';
  }

  // Stock
  var stockHTML = v.available
    ? '<div style="display:flex;align-items:center;gap:8px;font-size:12.5px;color:#16805a;font-weight:600;margin-bottom:12px;"><span style="width:8px;height:8px;border-radius:50%;background:currentColor;box-shadow:0 0 0 3px rgba(22,128,90,0.15);flex-shrink:0;display:inline-block;"></span>In stock — ready to ship today</div>'
    : '<div style="display:flex;align-items:center;gap:8px;font-size:12.5px;color:#b91c1c;font-weight:600;margin-bottom:12px;"><span style="width:8px;height:8px;border-radius:50%;background:currentColor;flex-shrink:0;display:inline-block;"></span>Out of stock</div>';

  // Meta
  var skuHTML    = v.sku ? '<span style="font-size:11.5px;color:#6b7280;">SKU: <strong style="color:#111;">' + v.sku + '</strong></span>' : '';
  var vendorHTML = product.vendor ? '<span style="font-size:11.5px;color:#6b7280;">Brand: <strong style="color:#111;">' + product.vendor + '</strong></span>' : '';
  var metaRow = (skuHTML || vendorHTML)
    ? '<div style="display:flex;align-items:center;gap:14px;flex-wrap:wrap;padding-top:10px;border-top:1px solid #f0f1f3;margin-top:8px;">' + skuHTML + (skuHTML && vendorHTML ? '<span style="width:3px;height:3px;border-radius:50%;background:#d1d5db;display:inline-block;"></span>' : '') + vendorHTML + '</div>'
    : '';

  // Description
  var descHTML = product.description
    ? '<div style="margin-top:14px;padding-top:14px;border-top:1px solid #f0f1f3;">' +
        '<p style="font-size:11px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.06em;margin:0 0 8px;">Description</p>' +
        '<div style="font-size:13px;color:#374151;line-height:1.6;max-height:130px;overflow-y:auto;">' + product.description + '</div>' +
      '</div>'
    : '';

  var mainImgSrc = images.length ? (typeof images[0] === 'string' ? images[0] : images[0].src) : '';

  var html =
    '<div style="display:grid;grid-template-columns:1fr 500px;min-height:500px;max-height:88vh;">' +

      // Left: images
      '<div style="background:#fff;border-right:1px solid #e8eaed;border-radius:8px 0 0 8px;padding:28px;display:flex;flex-direction:column;gap:16px;align-items:center;justify-content:center;">' +
        '<div style="width:100%;aspect-ratio:1;display:flex;align-items:center;justify-content:center;overflow:hidden;">' +
          '<img id="qv-main-img" src="' + mainImgSrc + '" style="max-width:100%;max-height:100%;object-fit:contain;">' +
        '</div>' +
        (images.length > 1 ? '<div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:center;">' + thumbsHTML + '</div>' : '') +
      '</div>' +

      // Right: info
      '<div style="background:#f7f7f7;border-radius:0 8px 8px 0;display:flex;flex-direction:column;gap:10px;padding:20px;overflow-y:auto;">' +
        '<div style="background:#fff;border:1px solid #e8eaed;border-radius:4px;padding:18px 20px;">' +
          '<h2 style="font-size:20px;font-weight:800;color:#111;line-height:1.2;margin:0 0 8px;">' + product.title + '</h2>' +
          metaRow +
          '<div style="height:12px;"></div>' +
          '<div style="margin-bottom:10px;">' + priceHTML + '</div>' +
          stockHTML +
          (optionsHTML ? '<div>' + optionsHTML + '</div>' : '') +
          '<div style="display:grid;grid-template-columns:110px 1fr;gap:10px;margin-top:14px;">' +
            '<div style="display:flex;align-items:center;justify-content:center;background:#fff;border:1.5px solid #e0e3e8;border-radius:4px;">' +
              '<button type="button" id="qv-qty-minus" style="width:34px;height:42px;background:none;border:none;cursor:pointer;font-size:18px;font-weight:600;color:#6b7280;">−</button>' +
              '<input type="number" id="qv-qty" value="1" min="1" style="width:40px;border:none;text-align:center;font-size:14px;font-weight:600;font-family:\'DM Sans\',sans-serif;-moz-appearance:textfield;background:transparent;">' +
              '<button type="button" id="qv-qty-plus" style="width:34px;height:42px;background:none;border:none;cursor:pointer;font-size:18px;font-weight:600;color:#6b7280;">+</button>' +
            '</div>' +
            '<button type="button" id="qv-atc" data-variant-id="' + v.id + '" ' + (!v.available ? 'disabled' : '') + ' style="height:42px;background:#1e3a72;color:#fff;border:none;border-radius:4px;font-size:14px;font-weight:700;font-family:\'DM Sans\',sans-serif;cursor:pointer;">' +
              (v.available ? 'Add to Cart' : 'Sold Out') +
            '</button>' +
          '</div>' +
          descHTML +
        '</div>' +
        '<a href="' + product.url + '" style="display:block;text-align:center;font-size:13px;color:#1e3a72;font-weight:600;text-decoration:underline;text-underline-offset:3px;padding:4px 0;">View full product details →</a>' +
      '</div>' +
    '</div>';

  $("#quick-view .qv-wrapper").html(html);

  // Bind events
  $(document).off('.qvthumb').on('click.qvthumb', '.qv-thumb', function () {
    $('.qv-thumb').css('border-color', '#e8eaed');
    $(this).css('border-color', '#1e3a72');
    $('#qv-main-img').attr('src', $(this).data('src'));
  });

  $(document).off('.qvqty')
    .on('click.qvqty', '#qv-qty-minus', function () {
      var val = parseInt($('#qv-qty').val()) || 1;
      if (val > 1) $('#qv-qty').val(val - 1);
    })
    .on('click.qvqty', '#qv-qty-plus', function () {
      $('#qv-qty').val((parseInt($('#qv-qty').val()) || 1) + 1);
    });

  $(document).off('.qvvariant').on('change.qvvariant', '.qv-option-select', function () {
    var selected = [];
    $('.qv-option-select').each(function () { selected.push($(this).val()); });
    var match = product.variants.find(function (v) {
      return selected.every(function (val, i) { return v.options[i] === val; });
    });
    if (!match) return;
    $('#qv-atc').data('variant-id', match.id).prop('disabled', !match.available).text(match.available ? 'Add to Cart' : 'Sold Out');
    $('.qv-price').text(moneyFormat(match.price));
    if (match.featured_image && match.featured_image.src) {
      $('#qv-main-img').attr('src', match.featured_image.src);
    }
  });

  $(document).off('.qvatc').on('click.qvatc', '#qv-atc', function () {
    var variantId = $(this).data('variant-id');
    var qty = parseInt($('#qv-qty').val()) || 1;
    qvAddToCart(variantId, qty, $(this));
  });
}

function quickView() {
  $(".quick-view").off("click.qvopen").on("click.qvopen", function (e) {
    e.preventDefault();
    e.stopPropagation();

    var product_handle = $(this).data('handle');

    $("#quick-view .qv-wrapper").html(
      '<div style="display:flex;align-items:center;justify-content:center;height:500px;font-family:\'DM Sans\',sans-serif;color:#6b7280;font-size:14px;">Loading...</div>'
    );
    openQuickView();

    $.ajax({
      url: '/products/' + product_handle + '.js',
      dataType: 'json',
      timeout: 8000,
      success: function (product) { renderQuickView(product); },
      error: function (jqXHR, textStatus) {
        console.error('QuickView load error:', jqXHR.status, textStatus);
        $("#quick-view .qv-wrapper").html(
          '<div style="text-align:center;padding:60px;font-family:\'DM Sans\',sans-serif;color:#991b1b;">Could not load product. Please try again.</div>'
        );
      }
    });
  });
}

document.addEventListener('shopify:section:load', function () {
  quickView();
});